import { render, staticRenderFns } from "./PatientWeightInput.vue?vue&type=template&id=d3f93ada&scoped=true&"
import script from "./PatientWeightInput.vue?vue&type=script&lang=js&"
export * from "./PatientWeightInput.vue?vue&type=script&lang=js&"
import style0 from "./PatientWeightInput.vue?vue&type=style&index=0&id=d3f93ada&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3f93ada",
  null
  
)

export default component.exports